<template>
  <megabit-base-dialog
    :show-dialog="dialog"
    :width="1024"
    :fullscreen="!!authUser"
  >
    <template v-slot:body>
      <v-card dark>
        <v-toolbar dark>
          <v-btn icon dark @click="goBack()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Settings</v-toolbar-title>
        </v-toolbar>
        <v-tabs v-model="tab" :grow="true" dark>
          <v-tabs-slider color="red"></v-tabs-slider>

          <v-tab>Dados Principais</v-tab>
          <v-tab>Dados Financeiros</v-tab>
          <v-tab>Setup do Sistema</v-tab>

          <v-tabs-items v-model="tab">
            <v-tab-item>
              <principal />
            </v-tab-item>
            <v-tab-item>
              <financeiro />
            </v-tab-item>
            <v-tab-item>
              <flags />
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-card>
    </template>
  </megabit-base-dialog>
</template>

<script>
import { formRegisterMixin } from '@/mixins/component/form/FormRegisterMixin'
import MegabitBaseDialog from '@/components/shared/base-dialog/BaseDialog'

import Principal from '@/views/system/Tabs/Principal'
import Financeiro from '@/views/system/Tabs/Financeiro'
import Flags from '@/views/system/Tabs/Flags'
import { mapState } from 'vuex'

export default {
  name: 'FormConfigSistema',
  mixins: [formRegisterMixin],
  components: {
    MegabitBaseDialog,
    Principal,
    Financeiro,
    Flags,
  },
  data: () => ({
    dialog: true,
    tab: 0,
  }),
  computed: {
    ...mapState('authModule', ['authUser']),
    ...mapState('systemModule', ['currentSystem']),
  },
  methods: {
    goBack() {
      this.dialog = false
      this.$router.push({ name: 'Home' })
    },
  },
}
</script>

<style></style>
